import styled from 'styled-components';

export const TitleContainer = styled.div`
  font-size: 20px;
  font-family: 'Suit extra bold';
  font-weight: 700;
  margin-bottom: 20px;
  color: rgba(38, 38, 38, 1);
  ${({ theme }) =>
    theme.media.monitor(
      `
        font-size: 24px;
        margin-bottom: 30px;
    	`,
    )}
`;
